import React, { useState } from "react";
import "./HeroSection.css";

// MUI
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Box,
  Tooltip
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

export default function HeroSection() {

  const [videoOpen, setVideoOpen] = useState(false);

  return (
    <div className="hero-container">

      <div className="hero-inner">

        <h1>
          Get the Best Possible Engineering College <br />
          at Your CET Score
        </h1>

        <p className="hero-subtitle">
          Data-driven prediction, preference strategy & complete CAP + Non-CAP guidance
        </p>

        {/* 🔥 BUTTON WITH TOOLTIP */}
        <Tooltip title="Watch Now" arrow placement="top">
          <button
            className="hero-btn"
            onClick={() => setVideoOpen(true)}
          >
            ▶ Before Admission Begins
          </button>
        </Tooltip>

      </div>

      {/* ===== TUTORIAL VIDEO DIALOG ===== */}
      <Dialog
        open={videoOpen}
        onClose={() => setVideoOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    p: { xs: 1.2, sm: 2 },   // smaller padding on phones
  }}
>
  <Typography
    sx={{
      fontWeight: 600,
      fontSize: { xs: "15px", sm: "18px" },  // smaller title on mobile
      lineHeight: 1.3
    }}
  >
    Before Admission Begins – Complete Guide
  </Typography>

  <IconButton
    onClick={() => setVideoOpen(false)}
    sx={{ p: { xs: 0.5, sm: 1 } }}  // smaller close button
  >
    <CloseIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
  </IconButton>
</DialogTitle>

        <DialogContent dividers sx={{ p: 0 }}>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              paddingTop: "56.25%", // 16:9 ratio
              backgroundColor: "#000"
            }}
          >
            <iframe
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: 0
              }}
              src="https://player.vimeo.com/video/1166281267?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              title="Admission Guide"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Box>
        </DialogContent>
      </Dialog>

    </div>
  );
}
